<div class="flex flex-row items-center justify-between m-1 text-left">
  <div class="text-xl font-bold w-full pl-5">
    {{ '' | libTranslateLang: titleEn() : titleFr() }}
  </div>
  <button mat-icon-button (click)="closeClick.emit()" [disabled]="disabled()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="border-t border-t-gray-200 m-0 hr-dialog-line-temp" style="border-top-style: solid"></div>
